<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card full-screen >

            <div class="modal-card ">
                <header class="modal-card-head"  >

<!--                    {{level1Selected}}-->
<!--                    {{level2Selected}}-->
<!--                    {{level3Selected}}-->
<!--                    {{level4Selected}}-->
<!--                    {{level5Selected}}-->

                </header>
                <section class="modal-card-body"  >
                    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>

<!--                    <b-tabs v-model="activeTab">-->
<!--                        <b-tab-item label="Dx Code">-->



<!--                             Level 1                                   -->
                                <div class="container">
                                    <nav class="panel">
                                        <div class="panel-heading">
                                         <HeadPanelDxCodeManagement
                                                 :level="1"
                                                 :levelTitle="levelDxLabel[0]"
                                                 :levelSelected="level1Selected"
                                                 :idparent="null"
                                                 @closeEditAddDxCodeWithDataChange="closeEditAddDxCodeWithDataChange"
                                                 @reloadEach="reloadEach"/>
                                        </div>
                                        <div class="panel-block">
                                            <DxTableData
                                                    ref="DxTableData1"
                                                    :dataTable = "level1"
                                                    :level=1
                                                    @dataSelected="dataSelected"
                                                    />
                                        </div>
                                    </nav>
                                </div>

                            <br>
                            <br>

<!--                             Level 2                  "            -->
                                <div class="container">
                                <nav class="panel">
                                    <div class="panel-heading">
                                        <HeadPanelDxCodeManagement
                                                :level="2"
                                                :levelTitle="levelDxLabel[1]"
                                                :levelSelected="level2Selected"
                                                :idparent="level1Selected ? level1Selected.id : null"
                                                @closeEditAddDxCodeWithDataChange="closeEditAddDxCodeWithDataChange"
                                                @reloadEach="reloadEach"/>
                                    </div>


                                    <div class="panel-block">
                                       <DxTableData
                                        ref="DxTableData2"
                                        :dataTable = "level2"
                                        :level=2
                                        @dataSelected="dataSelected"
                                          />
                                    </div>
                                </nav>
                            </div>
                            <br>
                            <br>
<!--                             Level 3                                   -->
                            <div class="container">
                                <nav class="panel">
                                    <div class="panel-heading">
                                        <HeadPanelDxCodeManagement
                                                :level="3"
                                                :levelTitle="levelDxLabel[2]"
                                                :levelSelected="level3Selected"
                                                :idparent="level2Selected ? level2Selected.id : null"
                                                @closeEditAddDxCodeWithDataChange="closeEditAddDxCodeWithDataChange"
                                                @reloadEach="reloadEach"/>
                                    </div>


                                    <div class="panel-block">
                                        <DxTableData
                                                ref="DxTableData3"
                                                :dataTable = "level3"
                                                :level=3
                                                @dataSelected="dataSelected"
                                                 />
                                    </div>
                                </nav>
                            </div>
                            <br>
                            <br>
 <!--                             Level 4                                   -->
                            <div class="container">
                                <nav class="panel">
                                    <div class="panel-heading">
                                        <HeadPanelDxCodeManagement
                                                :level="4"
                                                :levelTitle="levelDxLabel[3]"
                                                :levelSelected="level4Selected"
                                                :idparent="level3Selected ? level3Selected.id : null"
                                                @closeEditAddDxCodeWithDataChange="closeEditAddDxCodeWithDataChange"
                                                @reloadEach="reloadEach"/>
                                    </div>


                                    <div class="panel-block">
                                        <DxTableData
                                                ref="DxTableData4"
                                                :dataTable = "level4"
                                                :level=4
                                                @dataSelected="dataSelected"
                                                  />
                                    </div>
                                </nav>
                            </div>
                            <br>
                            <br>
<!--                             Level 5                                   -->
                            <div class="container">
                                <nav class="panel">
                                    <div class="panel-heading">
                                        <HeadPanelDxCodeManagement
                                                :level="5"
                                                :levelTitle="levelDxLabel[4]"
                                                :levelSelected="level5Selected"
                                                :idparent="level4Selected ? level4Selected.id : null"
                                                @closeEditAddDxCodeWithDataChange="closeEditAddDxCodeWithDataChange"
                                                @reloadEach="reloadEach"/>
                                    </div>


                                    <div class="panel-block">
                                        <DxTableData
                                                ref="DxTableData5"
                                                :dataTable = "level5"
                                                :level=5
                                                @dataSelected="dataSelected"
                                                 />
                                    </div>
                                </nav>
                            </div>
<!--                        </b-tab-item>-->

<!--                        <b-tab-item label="Main All Data (View)">-->

<!--                        </b-tab-item>-->
<!--                    </b-tabs>-->

                </section>
                <footer class="modal-card-foot">
                    <b-button size="is-medium" type="is-danger"
                                         icon-left="close" @click="$emit('close')">
                       Close
                    </b-button>

                </footer>



            </div>

        </b-modal>
    </form>
</template>

<script>

    import globalconst from "../../../mixins/globalconst";
    import axios from "axios";
    import { getBaseURLforBackEnd , getConfigAxios }  from '@/utils.js'
    import HeadPanelDxCodeManagement from "./HeadPanelDxCodeManagement";
    import DxTableData from "./DxTableData";

    export default {
        name: "DxCodeManagement",
        components:{
            HeadPanelDxCodeManagement,
            DxTableData
        },
        mounted() {
            this.intiData()
        },
        props:{
            isComponentModalActive : Boolean
        },
        mixins:[globalconst],
        methods:{
            reloadEach (payload){

                this.fetchLevel(payload.level,payload.idparent)
                if(payload.level === 1){
                    this.$refs.DxTableData1.clearDataSelected()
                    this.level1Selected = null
                }else if(payload.level === 2){
                    this.$refs.DxTableData2.clearDataSelected()
                    this.level2Selected = null
                }else if(payload.level === 3){
                    this.$refs.DxTableData3.clearDataSelected()
                    this.level3Selected = null
                }else if(payload.level === 4){
                    this.$refs.DxTableData4.clearDataSelected()
                    this.level4Selected = null
                }else if(payload.level === 5){
                    this.$refs.DxTableData5.clearDataSelected()
                    this.level5Selected = null
                }


            },
            closeEditAddDxCodeWithDataChange(payload){
                // payload === {idparent: "sEtMWWi45VzJ", level: 2, mode: 1}
                this.reloadEach({"level":payload.level,"idparent":payload.idparent})
            },
            dataSelected(payload){
                // console.log(JSON.stringify( payload) )
                if(payload.level===1){
                    this.level1Selected = payload.data_selected
                    this.level2Selected = null
                    this.level3Selected = null
                    this.level4Selected = null
                    this.level5Selected = null
                }
                if(payload.level===2){
                    this.level2Selected = payload.data_selected
                    this.level3Selected = null
                    this.level4Selected = null
                    this.level5Selected = null
                }
                if(payload.level===3){
                    this.level3Selected = payload.data_selected
                    this.level4Selected = null
                    this.level5Selected = null
                }
                if(payload.level===4){
                    this.level4Selected = payload.data_selected
                    this.level5Selected = null
                }
                if(payload.level===5){
                    this.level5Selected = payload.data_selected
                }

                this.fetchLevel(payload.level+1,payload.data_selected.id)
            },
            intiData(){
                this.fetchLevel(1,null)
            },
            fetchLevel(level,idparent){
                const vm = this
                const datTo ={
                    "idparent": idparent,
                    "admin" : true
                }
                this.isFullScreenLoading = true

                axios.post(`${getBaseURLforBackEnd()}/api/listofdiseasecode`,datTo,getConfigAxios())
                    .then((res)=>{
                        if (level === 1) {
                            // console.log('fetch level 1')
                            vm.level1 = res.data
                            this.level2 = []
                            this.level3 = []
                            this.level4 = []
                            this.level5 = []
                            this.level2Selected = null
                            this.level3Selected = null
                            this.level4Selected = null
                            this.level5Selected = null
                        } else if(level === 2){
                            // console.log('fetch level 2')
                            vm.level2 = res.data
                            this.level3 = []
                            this.level4 = []
                            this.level5 = []
                            this.level3Selected = null
                            this.level4Selected = null
                            this.level5Selected = null
                        }else if(level === 3){
                            // console.log('fetch level 3')
                            vm.level3 = res.data
                            this.level4 = []
                            this.level5 = []
                            this.level4Selected = null
                            this.level5Selected = null
                        }else if(level === 4){
                            // console.log('fetch level 4')
                            vm.level4 = res.data
                            this.level5 = []
                            this.level5Selected = null
                        }else if(level === 5){
                            // console.log('fetch level 5')
                            vm.level5 = res.data
                        }

                        // vm.isFullScreenLoading = false
                        setTimeout(()=>{
                            vm.isFullScreenLoading = false
                        },200)

                    })
                    .catch(()=>{
                        vm.isFullScreenLoading = false
                    })
            },
        },
        data(){
            return {
                isFullScreenLoading : false,
                activeTab : 0,
                level1 :  [] ,
                level1Selected : null,
                level2 :  [] ,
                level2Selected : null,
                level3 :  [] ,
                level3Selected : null,
                level4 :  [] ,
                level4Selected : null,
                level5 :  [] ,
                level5Selected : null,

                isEmpty : false,




            }
        } ,


    }
</script>

<style scoped>

</style>